export default __webpack_public_path__ + "static/media/close-black.34887378.svg";